import {
  CarsTrucks,
  AtvsUtvs,
  Snowmobiles,
  Watercrafts,
  ClassicCollectorCars,
  Motorcycles,
  Rvs,
  HeavyEquipments,
} from "./components";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return <CarsTrucks />;
}

export default App;
